import { render, staticRenderFns } from "./ReactDataTable.vue?vue&type=template&id=712fa674&"
import script from "./ReactDataTable.vue?vue&type=script&lang=js&"
export * from "./ReactDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ReactDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports